// Cody's Corral, Inc. — public-safe organization information.
//
// SECURITY: This file is bundled into the client and is fully readable from
// the browser. Keep its contents to information that is already public via
// the Ohio Secretary of State. Do NOT add the org's federal tax identifier
// or commercial registry numbers here — those live outside the repo.

export const COMPANY_NAME = "Cody's Corral, Inc.";
export const COMPANY_SHORT = "Cody's Corral";
export const COMPANY_TAGLINE = 'Healing through horses.';

export const COMPANY_CITY = 'Barnesville';
export const COMPANY_STATE = 'OH';
export const COMPANY_COUNTY = 'Belmont County';
export const COMPANY_LOCATION = 'Barnesville, Ohio';

// Public Ohio SOS principal-office record.
export const COMPANY_ADDRESS_FULL = '58530 Lower Sandy Ridge Rd, Barnesville, OH 43713';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=58530+Lower+Sandy+Ridge+Rd%2C+Barnesville%2C+OH+43713';

// Public Ohio Secretary of State record.
export const ORG_TYPE = 'Ohio Domestic Nonprofit Corporation';
export const CHARTER_NUMBER = '5121639';
export const EFFECTIVE_DATE = 'October 4, 2023';

// Mission text — verbatim from Articles of Incorporation, Third clause. Do not paraphrase.
export const MISSION =
  'To provide equine therapy to troubled youth, autistic individuals, veterans, and those who suffer from mental health issues.';

// Tax notice — until the IRS grants 501(c)(3) determination, this stays.
export const TAX_NOTICE =
  '501(c)(3) federal tax-exempt status with the IRS is pending. Donations may not yet be tax-deductible.';

// Contact placeholder — swap when the org provisions a real domain inbox.
export const CONTACT_EMAIL = 'info@codyscorral.org'; // PLACEHOLDER

export const COMPANY_FACTS = [
  { label: 'Founded',  value: '2023' },
  { label: 'Location', value: 'Barnesville, OH' },
  { label: 'Org Type', value: 'Ohio Nonprofit' },
];

export const WHO_WE_SERVE = [
  {
    id: 'youth',
    title: 'Troubled Youth',
    summary:
      'Young people facing trauma, behavioral challenges, or instability — building self-regulation through partnership with horses.',
  },
  {
    id: 'autistic',
    title: 'Autistic Individuals',
    summary:
      'Sensory-friendly, predictable interactions with horses that support communication, comfort, and confidence.',
  },
  {
    id: 'veterans',
    title: 'Veterans',
    summary:
      'Service members and veterans navigating PTSD, transition, and the search for purpose after duty.',
  },
  {
    id: 'mental-health',
    title: 'Mental Health',
    summary:
      'Adults and adolescents living with anxiety, depression, or grief — finding grounding through equine-assisted experiences.',
  },
];

export const WHY_EQUINE = [
  {
    title: 'Co-Regulation',
    body: 'Horses are large, sensitive prey animals — being near a calm horse gently invites the human nervous system to settle.',
  },
  {
    title: 'Honest Mirrors',
    body: 'Horses respond to body language and emotion in real time, giving immediate, non-judgmental feedback.',
  },
  {
    title: 'Beyond Words',
    body: 'Equine work meets people where words fall short — useful for trauma, neurodivergence, and pre-verbal experiences.',
  },
];

export const PROGRAMS = [
  {
    id: 'individual',
    title: 'Individual Sessions',
    summary:
      "1-on-1 ground-based equine experiences tailored to the participant's goals and pace.",
  },
  {
    id: 'group',
    title: 'Group Sessions',
    summary:
      'Small groups working alongside horses to build trust, communication, and shared experience.',
  },
  {
    id: 'family',
    title: 'Family & Caregiver Programs',
    summary:
      'Sessions that include parents, caregivers, or partners — strengthening connection through shared work with horses.',
  },
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Reach out',
    body: "Send a message describing who you'd like to bring and what you're hoping for.",
  },
  {
    step: '02',
    title: 'Intake',
    body: 'A short conversation about goals, history, and any sensory or physical considerations.',
  },
  {
    step: '03',
    title: 'Begin sessions',
    body: 'Meet at the ranch in Barnesville and start working alongside the horses at your pace.',
  },
];

export const GET_INVOLVED = [
  {
    audience: 'Refer',
    cta: 'Refer a participant',
    body: "Therapists, schools, and family members can refer someone they'd like us to support.",
  },
  {
    audience: 'Volunteer',
    cta: 'Volunteer',
    body: 'Help with chores, sessions, and events — no horse experience required for many roles.',
  },
  {
    audience: 'Sponsor',
    cta: 'Sponsor a session',
    body: 'Sponsor a session, a month of feed, or a saddle — every contribution lowers the barrier for participants.',
  },
];
